import React from "react";
import {pathTo} from "./utils";
import {Breadcrumb as Crumb} from "react-bootstrap";
import './breadcrumb.scss'
import {Link, withRouter} from "react-router-dom";

const Breadcrumb = ({route}) => (
    <Crumb className={!route.title ? "wrapper" : undefined}>
        {pathTo(route).map((crumb, index, breadcrumbs) => (
            <li className={`breadcrumb-item ${!crumb.component || index === breadcrumbs.length - 1 ? "active" : ""}`}
                key={index}>
                {!crumb.component || index === breadcrumbs.length - 1 ? crumb.label :
                    <Link to={crumb.path}>{crumb.label}</Link>}
            </li>
        ))}
    </Crumb>
);

export default withRouter(Breadcrumb);